import SparePartPageApi from "../api/SparePartPageApi";

export const getSparePartPage = (containerName : string, document: string)  => {
    return SparePartPageApi.getSparePartPage(containerName, document);
}